/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CreateLeadResponse } from '../models/create-lead-response';
import { leadsControllerCreateMarketingLead } from '../fn/leads-controller/leads-controller-create-marketing-lead';
import { LeadsControllerCreateMarketingLead$Params } from '../fn/leads-controller/leads-controller-create-marketing-lead';
import { leadsControllerCreateSalesLead } from '../fn/leads-controller/leads-controller-create-sales-lead';
import { LeadsControllerCreateSalesLead$Params } from '../fn/leads-controller/leads-controller-create-sales-lead';


/**
 * API resource for project lead management.
 */
@Injectable({ providedIn: 'root' })
export class LeadsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `leadsControllerCreateMarketingLead()` */
  static readonly LeadsControllerCreateMarketingLeadPath = '/planning-projects/v2/projects/{projectId}/leads/marketing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `leadsControllerCreateMarketingLead()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  leadsControllerCreateMarketingLead$Response(params: LeadsControllerCreateMarketingLead$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateLeadResponse>> {
    return leadsControllerCreateMarketingLead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `leadsControllerCreateMarketingLead$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  leadsControllerCreateMarketingLead(params: LeadsControllerCreateMarketingLead$Params, context?: HttpContext): Observable<CreateLeadResponse> {
    return this.leadsControllerCreateMarketingLead$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateLeadResponse>): CreateLeadResponse => r.body)
    );
  }

  /** Path part for operation `leadsControllerCreateSalesLead()` */
  static readonly LeadsControllerCreateSalesLeadPath = '/planning-projects/v2/projects/{projectId}/leads/sales';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `leadsControllerCreateSalesLead()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  leadsControllerCreateSalesLead$Response(params: LeadsControllerCreateSalesLead$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateLeadResponse>> {
    return leadsControllerCreateSalesLead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `leadsControllerCreateSalesLead$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  leadsControllerCreateSalesLead(params: LeadsControllerCreateSalesLead$Params, context?: HttpContext): Observable<CreateLeadResponse> {
    return this.leadsControllerCreateSalesLead$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateLeadResponse>): CreateLeadResponse => r.body)
    );
  }

}
